export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f84a2a5ca952dc52c86b7e2839bda9ebf8110e6ad&name=fetchTypeahead!'